<!-- // Created by 任泽阳 on 18/12/06.
// 登录页面 -->
<template>
  <div class="login-box flex-center main-bg">
    <div class="login-main flex-between main-second-bg">
      <div class="login-left">
        <img class="login-img" src="@/assets/img/login.png"/>
      </div>
      <div class="login-right">
        <section class="page-login" >
          <div class="go-home-btn a-3-bd" @click="goUrl('/')" >
            <svg class="icon icon-18" aria-hidden="true">
                <use xlink:href="#icon-e_11"></use>
              </svg>
            {{ $t('pageTitle.home') }}
          </div>
          <div class="login-title-box flex-between">
            <span class="login-title main-cl">{{loginPageTitle}}</span>
            <p class="gray-cl login-tip">
              {{ $t('login.NotRegisteredUsersYet') }}？
              <span
                class="blue-cl"
                style="cursor: pointer;"
                @click="goUrl('/register')">
                {{$t('login.goRegister')}}
              </span>
            </p>
          </div>
          <!-- 主体 -->
          <div class="page-login-content">
            <div class="content-center">
              <!-- 手机/邮箱 -->
              <c-inputLine
                maxLength="100"
                name="userValue"
                :promptLightText="userInputPrompt"
                :promptText="$t('login.loginPrompt')"
                :errorHave="true"
                :errorText="$t('login.formatIncorrect')"
                :errorFlag="userErrorFlag"
                :value="userValue"
                :newStyleFormat="true"
                @onchanges="inputChanges">
              </c-inputLine>
              <!-- 密码 -->
              <!-- :errorHave="true"
                :errorText="$t('login.passwordError')"
                :errorFlag="passErrorFlag" -->
              <c-inputLine
                maxLength="20"
                name="passValue"
                :promptLightText="$t('login.password')"
                marginTop="0px"
                :value="passValue"
                :inputType="passwordInputType"
                @onchanges="inputChanges"
                :newStyleFormat="true"
                :isLogin="true"
                style="margin-bottom: 32px;"
              >
                <svg-icon
                  :iconClass="passwordVisible?'icon_visible':'icon_invisible'"
                  className="icon-18"
                  style="cursor: pointer; margin-left: 8px;"
                  @click="passwordVisible = !passwordVisible"></svg-icon>
              </c-inputLine>
              <!-- 极验 -->
              <!-- marginTop 70-40-24=4 -->
              <c-verify
                marginTop="16px"
                style="margin-bottom: 28px;"
                :errorHave="true"
                :colorMap="colorMap"
                @callback='verifyCallBack'/>
              <!-- <c-button type="text" className="logBtn"
                @click="goUrl('/resetPass')">
                {{$t('login.ForgetPassword')}}
              </c-button> -->
              <p class="forget-password blue-cl" @click="goUrl('/resetPass')">
                {{ $t('login.ForgetPassword') }}
              </p>
              <c-button type="solid"
                :disabled="submitDisabled"
                :loading="submitLoading"
                marginTop="8px"
                height="40px"
                width="100%"
                paddingW="0px"
                style="font-size:16px;"
                @click="submit">{{loginButtonText}}
              </c-button>
              <div class="thirdBox" v-if="thirdList && !singPassCode && !singpassState">
                <!-- 其他登录方式 -->
                <div class="thirdBoxTitle b-2-cl">
                  {{$t('singPassLogin.mainText1')}}
                </div>
                <div class="thirdInfor a-2-bd"
                  @click="goThirdUrl(thirdList[0])"
                  @mouseover.stop="addHover('0')"
                  @mouseout.stop="removeHover()"
                  :class="{ 'a-4-bg':  '0' === addHoverclass, 'notborder': thirdList.length < 2}">
                  <img :src="thirdList[0].img" >
                  <div class="thirdName">{{thirdList[0].value}}</div>
                  <i v-if="thirdList.length > 1" class="dowm-icon"></i>
                </div>
                <div v-if="thirdList.length > 1" class="third-list a-5-bg b-1-cl">
                  <template v-for = "(item, index) in thirdList">
                    <div class="third-item"
                      :key="index"
                      v-if="index > 0"
                      :class="{ 'a-4-bg':  index === addHoverclass }"
                      @click="goThirdUrl(item)"
                      @mouseover="addHover(index)"
                      @mouseout="removeHover()">
                        <img :src="item.img" >
                        <div class="third-val">{{item.value}}</div>
                    </div>
                  </template>
                  </div>
              </div>
            </div>
          </div>
          <!-- 对话框  38-24=14 -->
          <c-dialog :showFlag="dialogFlag"
            paddingBottom="14px"
            :confirmLoading="dialogConfirmLoading"
            :confirmDisabled="dialogConfirmDisabled"
            @close="dialogClose"
            @confirm="dialogConfirm"
            :titleText="$t('login.SecurityVerification')">
            <!-- 验证框 -->
            <c-inputLine
              maxLength="6"
              name="checkValue"
              :promptText="checkOptions.text"
              :errorHave="true"
              :errorText="checkText"
              :errorFlag="checkErrorFlag"
              marginTop="0px"
              :value="checkValue"
              @onchanges="inputChanges"
            >
              <!-- 获取验证码 -->
              <c-getCode v-if="checkOptions.haveCode"
                name="loginGetcode"
                @click="getCodeClick"
                buttonName="loginGetcodeBtn"/>
            </c-inputLine>
          </c-dialog>
          <div class="spcpqr-a5c3" style="dispaly: none;"></div>
          <singPassLogin :isShow="singPassDialogFlag" />
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from 'BlockChain-ui-privatization/utils';
import {
  myStorage,
  setCookie,
  imgMap,
  colorMap,
} from '@/utils';
import singPassLogin from './singPassLogin.vue';

export default {
  name: 'page-login',
  // mixins: [mixin],
  components: {
    singPassLogin,
  },
  data() {
    return {
      imgMap,
      colorMap,
      userValue: '', // 账号value
      passValue: '', // 密码value
      checkValue: '', // 验证码value
      checkType: '0', // 验证码类型( '1'-谷歌 '2'-手机 '3'-邮箱 )
      verifyObj: {}, // 滑动返回对象
      verifyFlag: false, // 滑动是否通过
      dialogFlag: false, // 弹窗flag
      submitLoading: false, // input框
      userToken: null, // 服务端第一次校验返回
      dialogConfirmLoading: false, // 用于弹窗按钮loading效果
      selectValue: 'google',
      addHoverclass: 0,
      singPassDialogFlag: false,
      thirdListShow: false,
      loginMode: null,
      passwordVisible: false,
      userSkin: getCookie('cusSkin') || getCookie('defSkin'), // 用户选择的skin
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    lan() {
      return this.$store.state.baseData.lan;
    },
    verificationType() {
      const { publicInfo } = this.$store.state.baseData;
      let type = '0';
      if (
        publicInfo
        && publicInfo.switch
        && publicInfo.switch.verificationType
      ) {
        type = publicInfo.switch.verificationType;
      }
      return type;
    },
    // 登录按钮文案
    loginButtonText() {
      if (this.loginMode === 'SingPass') {
        return this.$t('singPassLogin.mainText13'); // '登录并关联SingPass账号';
      }
      if (this.singPassCode && this.singpassState && this.singpassSource === 'reg') {
        return this.$t('singPassLogin.mainText13'); // '登录并关联SingPass账号';
      }
      return this.$t('login.login');
    },
    loginPageTitle() {
      if (this.loginMode === 'SingPass') {
        return this.$t('singPassLogin.mainText2'); // 'SingPass第三方登录';
      }
      if (this.singPassCode && this.singpassState && this.singpassSource === 'reg') {
        return this.$t('singPassLogin.mainText2'); // 'SingPass第三方登录';
      }
      return this.$t('login.WelcomeToLogin');
    },

    userInputPrompt() {
      let str = '';
      // const obj = {
      //   title: '',
      //   tip: this.$t('login.loginPrompt'),
      // };
      switch (this.loginRegistType) {
        case '1':
          // str = `${this.$t('login.phoneOrEmail')} ${this.$t('login.loginPrompt')}`;
          str = this.$t('login.phoneOrEmail');
          break;
        case '2':
          // str = `${this.$t('resetPass.phone')} ${this.$t('login.loginPrompt')}`;
          str = this.$t('resetPass.phone');
          break;
        case '3':
          str = this.$t('resetPass.email');
          break;
        default:
          // str = `${this.$t('login.phoneOrEmail')} ${this.$t('login.loginPrompt')}`;
          str = this.$t('login.phoneOrEmail');
      }
      return str;
    },
    // 开启验证方式
    loginRegistType() {
      // const { publicInfo } = this.$store.state.baseData;
      const str = '1'; // 1 手机/邮箱， 2 仅手机， 3 仅邮箱
      // if (publicInfo && publicInfo.switch && publicInfo.switch.login_regist_type) {
      //   str = publicInfo.switch.login_regist_type.toString();
      // }
      return str;
    },
    selectOptions() {
      const arr = [{ value: this.$t('login.GoogleAuthenticator'), code: 'google' }];
      if (this.loginRegistType === '2') {
        arr.push({ value: this.$t('login.MobilePhoneVerification'), code: 'phone' });
      } else if (this.loginRegistType === '3') {
        arr.push({ value: this.$t('login.MailboxValidation'), code: 'email' });
      } else {
        arr.push({ value: this.$t('login.MobilePhoneVerification'), code: 'phone' });
        arr.push({ value: this.$t('login.MailboxValidation'), code: 'email' });
      }
      return arr;
    },
    loginFlag() {
      const { isLogin, userInfoIsReady } = this.$store.state.baseData;
      if (isLogin && userInfoIsReady) {
        return true;
      }
      return false;
    },
    checkText() {
      switch (this.checkType) {
        case '1':
          // 请输入6位数字谷歌验证码
          return this.$t('login.googleCodeError');
        case '2':
          // 请输入6位数字手机验证码
          return this.$t('login.phoneCodeError');
        case '3':
          // 请输入6位数字邮箱验证码
          return this.$t('login.emailCodeError');
        default:
          // 请输入6位数字验证码
          return this.$t('login.codeError');
      }
    },
    // userValue 是否复合正则验证
    userFlag() {
      const { phone, email } = this.$store.state.regExp;
      if (this.loginRegistType === '2') {
        if (phone.test(this.userValue)) { return true; }
      } else if (this.loginRegistType === '3') {
        if (email.test(this.userValue)) { return true; }
      } else {
        if (phone.test(this.userValue)) { return true; }
        if (email.test(this.userValue)) { return true; }
      }
      return false;
    },
    // passValue 是否复合正则验证
    // passFlag() { return this.$store.state.regExp.passWord.test(this.passValue); },
    // checkValue 是否复合正则验证
    checkFlag() { return this.$store.state.regExp.verification.test(this.checkValue); },
    // 二次验证弹层 text展示文字 havacode是否有获取验证码
    checkOptions() {
      switch (this.checkType) {
        case '1':
          // 谷歌验证码
          return { text: this.$t('login.googleCode'), haveCode: false };
        case '2':
          // 手机验证码
          return { text: this.$t('login.phoneCode'), haveCode: true };
        case '3':
          // 邮箱验证码
          return { text: this.$t('login.emailCode'), haveCode: true };
        default:
          // 验证码
          return { text: this.$t('login.code'), haveCode: false };
      }
    },
    // user框是否为错误状态
    userErrorFlag() {
      if (this.userValue.length !== 0 && !this.userFlag) return true;
      return false;
    },
    // pass框是否为错误状态
    // passErrorFlag() {
    // if (this.passValue.length !== 0 && !this.passFlag) return true;
    // return false;
    // },
    // 验证框是否为错误
    checkErrorFlag() {
      if (this.checkValue.length !== 0 && !this.checkFlag) return true;
      return false;
    },
    // 登录button 禁用状态
    submitDisabled() {
      const {
        userFlag, submitLoading,
      } = this; // passFlag,
      // if (!(verificationType * 1) || !document.getElementsByClassName('nc_wrapper').length) {
      //   this.verifyFlag = true;
      // }
      if ((userFlag && this.verifyFlag) || submitLoading) { // && passFlag
        return false;
      }
      return true;
    },
    dialogConfirmDisabled() {
      if (!this.checkFlag && !this.dialogConfirmLoading) return true;
      return false;
    },
    publicInfo() {
      const { publicInfo } = this.$store.state.baseData;
      return publicInfo;
    },
    thirdList() {
      if (this.publicInfo && this.publicInfo.thirdInfo && this.publicInfo.thirdInfo.length > 0) {
        const arr = [];
        this.publicInfo.thirdInfo.forEach((item) => {
          arr.push({
            value: item.name,
            img: item.logoAddress,
            code: item.pcThirdUrl,
            sort: item.sort,
            pcJump: item.pcJump,
          });
        });
        const newArr = this.sortKey(arr, 'sort');
        return newArr;
      }
      return null;
    },
    thirdPartyLoginData() {
      return this.$store.state.baseData.thirdPartyLoginData;
    },
    singPassCode() {
      return this.$route.query.code;
    },
    singpassState() {
      return this.$route.query.state;
    },
    singpassSource() {
      return this.$route.query.source;
    },
    // 密码框类型
    passwordInputType() {
      return this.passwordVisible ? 'text' : 'password';
    },
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    // 二次校验
    dialogConfirm() {
      this.dialogConfirmLoading = true;
      const params = {
        token: this.userToken,
        authCode: this.checkValue,
        type: this.selectValue,
      };
      // 判断是否是 第三方 登录
      if (this.singPassCode && this.singpassState) {
        params.singPassCode = this.singPassCode;
      }
      this.axios({
        url: 'user/confirm_login',
        method: 'post',
        params,
      }).then((data) => {
        this.dialogConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.dialogClose(); // 关闭弹窗
          setCookie('token', this.userToken); // 存储cookie
          // 登录成功
          this.$bus.$emit('tip', { text: this.$t('login.loginSuccess'), type: 'success' });
          // 获取 userinfo
          this.$store.dispatch('getUserInfo');
          this.getMySymbol();
          // 登录以后要删除合约缓存保证进到合约的时候显示BTCUSDT
          myStorage.remove('contractName');
          myStorage.remove('contractId');
          this.$router.push('/dist');
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    init() {
      if (this.loginFlag) { this.goHome(); }
      this.$bus.$off('emailCode');
      this.$bus.$on('emailCode', (data) => {
        const newData = JSON.parse(JSON.stringify(data));
        newData.callback = undefined;
        this.axios({
          url: 'v4/common/emailValidCode',
          method: 'post',
          header: {},
          params: newData,
        }).then((info) => {
          data.callback(info);
        }).catch(() => {
        });
      });
      this.$bus.$off('phoneCode');
      this.$bus.$on('phoneCode', (data) => {
        const newData = JSON.parse(JSON.stringify(data));
        newData.callback = undefined;
        this.axios({
          url: 'v4/common/smsValidCode',
          method: 'post',
          header: {},
          params: newData,
        }).then((info) => {
          data.callback(info);
        }).catch(() => {
          // console.log(info);
        });
      });
      this.$bus.$on('closeSingPassDialog', () => {
        this.singPassDialogFlag = false;
      });
      this.$bus.$on('setLoginMode', (info) => {
        this.loginMode = info;
      });
    },
    sortKey(array, key) {
      return array.sort((a, b) => {
        const x = a[key];
        const y = b[key];
        return (x - y); // 从小到大排序
      });
    },
    changeThird(item) {
      if (item.pcJump === '1') {
        window.open(item.code, '_blank');
      }
    },
    addHover(num) {
      this.addHoverclass = num;
      this.thirdListShow = true;
    },
    removeHover() {
      this.addHoverclass = null;
      // setTimeout(() => {
      //   this.thirdListShow = false;
      // });
    },
    goUrl(url) {
      // 如果是第三方登录 跳转到注册也是第三方注册
      if (url === '/register' && this.singPassCode && this.singpassState) {
        this.$router.push(`${url}?singPassCode=${this.singPassCode}&singPassState=${this.singpassState}`);
      } else {
        this.$router.push(url);
      }
    },
    // goHome() { window.location.href = '/'; },
    // input onchanges事件
    inputChanges(value, name) {
      this[name] = value;
    },
    selectChange(item) {
      this.selectValue = item.code;
    },
    submit() {
      const params = {
        ...this.verifyObj,
        ...{
          mobileNumber: this.userValue,
          loginPword: this.passValue,
          nc: null,
          // type: this.selectValue,
        },
      };
      this.submitLoading = true;
      this.axios({
        url: 'user/login_in',
        headers: {},
        params,
        method: 'post',
      }).then((data) => {
        if (this.verifyObj && this.verifyObj.nc) {
          this.verifyObj.nc.reset(); // 滑动重置
        }
        this.verifyFlag = false; // 验证通过置未未通过
        this.submitLoading = false; // button按钮loading取消
        if (data.code.toString() === '0') {
          this.dialogFlag = true; // 打开弹窗
          this.checkType = data.data.type; // '1'-谷歌 '2'-手机 '3'-邮箱
          this.userToken = data.data.token;
          this.$nextTick(() => {
            // 验证码input获取焦点
            this.$bus.$emit('inputLine-focus', 'checkValue');
            // 触发发送验证码button
            this.$bus.$emit('button-click', 'loginGetcodeBtn');
          });
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 极验滑动通过
    verifyCallBack(parameter) {
      this.verifyObj = parameter;
      this.verifyFlag = true;
    },
    // 二次校验
    // dialogConfirm() {
    //   this.dialogConfirmLoading = true;
    //   const params = {
    //     token: this.userToken,
    //     authCode: this.checkValue,
    //     type: this.selectValue,
    //   };
    //   // 判断是否是 第三方 登录
    //   if (this.singPassCode && this.singpassState) {
    //     params.singPassCode = this.singPassCode;
    //   }
    //   this.axios({
    //     url: 'user/confirm_login',
    //     method: 'post',
    //     params,
    //   }).then((data) => {
    //     this.dialogConfirmLoading = false;
    //     if (data.code.toString() === '0') {
    //       this.dialogClose(); // 关闭弹窗
    //       setCookie('token', this.userToken); // 存储cookie
    //       // 登录成功
    //       this.$bus.$emit('tip', { text: this.$t('login.loginSuccess'), type: 'success' });
    //       // 获取 userinfo
    //       this.$store.dispatch('getUserInfo');
    //       this.getMySymbol();
    //       window.location.href = '/';
    //     } else {
    //       this.$bus.$emit('tip', { text: data.msg, type: 'error' });
    //     }
    //   });
    // },
    // 关闭弹窗
    dialogClose() {
      this.dialogFlag = false;
      this.checkValue = '';
    },
    // 发送验证码组件点击button
    getCodeClick() {
      this.sendCode();
    },
    // 发送验证码
    sendCode() {
      if (this.checkType === '2') {
        this.$bus.$emit('phoneCode', {
          token: this.userToken,
          operationType: '25',
          callback: (data) => {
            if (data.code.toString() !== '0') {
              // 倒计时重置
              this.$bus.$emit('getCode-clear', 'loginGetcode');
              // tip框提示错误
              this.$bus.$emit('tip', { text: data.msg, type: 'error' });
            } else {
              // 短信已发送，请注意查收
              this.$bus.$emit('tip', { text: this.$t('login.phoneSendSuccess'), type: 'success' });
            }
          },
        });
      } else if (this.checkType === '3') {
        this.$bus.$emit('emailCode', {
          token: this.userToken,
          operationType: '4',
          callback: (data) => {
            if (data.code.toString() !== '0') {
              // 倒计时重置
              this.$bus.$emit('getCode-clear', 'loginGetcode');
              // tip框提示错误
              this.$bus.$emit('tip', { text: data.msg, type: 'error' });
            } else {
              // 邮件已发送，请注意查收
              this.$bus.$emit('tip', { text: this.$t('login.emailSendSuccess'), type: 'success' });
            }
          },
        });
      }
    },
    // 获取服务端自选币对
    getMySymbol() {
      const url = this.$store.state.url.common.market_collect_get_symbol;
      this.axios({
        url: url,
        params: {
          type: null,
        },
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          const storageMySymbol = myStorage.get('mySymbol') || [];
          let webMySymbol = [];
          if (Array.isArray(data.data) && data.data.length > 0) {
            webMySymbol = data.data.map(item => item.code);
          }
          const sumMySymbolList = Array.from(new Set([...storageMySymbol, ...webMySymbol]));
          const diffMySymbolList = storageMySymbol.filter(x => !webMySymbol.includes(x));
          // 同步本地自选币对和服务端币对
          if (diffMySymbolList.length !== 0) {
            myStorage.set('mySymbol', sumMySymbolList);
            const symbols = [];
            diffMySymbolList.forEach((symbol) => {
              symbols.push({
                type: symbol.indexOf('/') > -1 ? '0' : '1', // 0 现货 1 合约
                code: symbol,
              });
            });
            this.axios({
              url: this.$store.state.url.common.market_collect_add_batch_symbol,
              params: {
                key: symbols,
              },
              method: 'post',
            }).then(() => {});
          } else {
            myStorage.set('mySymbol', webMySymbol);
          }
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 点击第三方登录
    goThirdUrl(data) {
      // 直接跳转至第三方
      if (data.pcJump === '1') {
        window.open(data.code, '_blank');
      } else {
        // 请求第三方登录信息
        this.$store.dispatch('thirdPartyLoginData', {
          url: data.code,
          data: {},
        });
      }
    },
  },
  watch: {
    checkValue(newV) {
      if (newV.length === 6) {
        this.$nextTick(() => {
          this.$bus.$emit('button-click', 'dialogConfirm');
        });
      }
    },
    loginFlag(v) { if (v) { this.goHome(); } },
    // 第三方登录信息
    thirdPartyLoginData(data) {
      if (data !== null) {
        this.loading = false;
        if (data.text === 'success') {
          // 打开 singPass 弹框
          this.singPassDialogFlag = true;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-login {
  .guide-center {
    p {
      font-family: PingFangSC-Regular;
      font-size: 32px;
      text-align: center;
      line-height: 52px;
      margin-top: 59px;
    }
    .guide-text {
      margin-top: 12px;
      font-size: 14px;
      text-align: center;
    }
    .guide-ht {
      vertical-align: middle;
    }
    .goRegister {
      vertical-align: middle;
      font-size: 14px;
    }
  }
  // 主体
  .page-login-content {
    padding: 40px 0 32px; // 90 - 43
    .content-center {
      // width: 380px;
      margin: 0 auto;
      // 忘记密码
      .forgetPassword {
        font-size: 12px;
        line-height: 20px;
        margin-top: 6px;
      }
      .thirdBox{
        margin-top: 20px;
        position: relative;
        .thirdBoxTitle{
          font-size:14px;
          margin-bottom:6px;
        }
        .thirdInfor{
          width: 100%;
          height: 100%;
          cursor:pointer;
          padding: 6px 0;
          border-bottom-width: 2px;
          border-bottom-style: solid;
          height: 32px;
          img{
            width:32px;
            height:32px;
            border-radius:50%;
            float:left;
            margin-right:10px;
          }
          .thirdName{
            float:left;
            line-height:32px;
          }
          .dowm-icon {
            border-style: solid;
            float: right;
            width: 6px;
            height: 6px;
            border-width: 0;
            margin: 12px 20px 0 0;
            border-bottom-width: 2px;
            border-right-width: 2px;
            transform:rotate(45deg);
          }
        }
        .notborder {
          border: none;
        }
        .third-list {
          position: absolute;
          transform-origin: center top 0px;
          top: 66px;
          left: 0;
          right: 0;
          z-index: 9;
          box-shadow: 0 3px 4px 1px rgba(0,0,0,0.28);
          border-radius: 2px;
          font-size: 14px;
          padding: 10px 0;
          display: none;
        }
        &:hover{
          .third-list {
            display: block;
          }
        }
        .third-item {
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          padding: 6px 20px;
          img{
            width:32px;
            height:32px;
            border-radius:50%;
            float:left;
            margin-right:10px;
          }
          .third-val{
            float:left;
            line-height:32px;
          }
        }
      }
    }
  }
}
// .guide-center{
//   .logBtn{
//     .common-button-slot{
//       color: #1baaec !important;
//     }
//   }
// }
.page-login-content{
  .logBtn{
    .common-button-slot{
      color: #1baaec !important;
    }
  }
}
// 返回首页按钮
.go-home-btn {
  border-width: 1px;
  border-style: solid;
  height: 30px;
  line-height: 30px;
  width: 110px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 10;
  user-select: none;
  display: none;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-box {
  width: 100%;
  min-height: 800px;
  // height: calc(100vh - 64px);
  .login-main {
    width: 932px;
    padding: 24px 40px 24px;
    box-sizing: border-box;
    border-radius: 16px;
    .login-left {
      width: 365px;
    }

    .login-img, .login-icon {
      display: block;
    }
    .login-img {
      height: 297px;
      margin: 46px 0 78px 5px;
    }
    .login-icon {
      height: 30px;
    }
    .login-title-box {
      align-items: baseline;
      .login-title {
        font-size: 36px;
        line-height: 50px;
        font-family: 'Regular';
        font-weight: 500;
      }
      .login-tip {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .login-right {
      flex: 1;
      margin-left: 85px;
    }
  }
  .forget-password {
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }
}
</style>
